<template>
  <footer class="footer">
    <div class="container py-5">
      <div class="row">
        <!-- Company Info Section -->
        <div class="col-lg-3 mb-4 mb-lg-0">
          <div class="footer-logo mb-4">
            <img src="https://cdn-icons-png.flaticon.com/512/240/240191.png" alt="Book Store Logo" width="30" height="30" class="me-2">
            <span class="logo-text">Nilkhet Books</span>
          </div>
          <p class="address mb-3">
            <!-- Gausul Azam Super Market<br />Nilkhet, Dhaka 1205 -->
            Shop 146, 1st Floor, <br />
            Gausul Azam Super Market, <br />
            Nilkhet, Dhaka 1205
          </p>
          <a href="https://maps.app.goo.gl/MByh9Csc8wc3xDJQ9" target="_blank" class="map-btn">
            SHOW ON MAP
          </a>
          <div class="social-icons mt-4">
            <a href="https://www.facebook.com/nilkhet.com.bd/" target="_blank" class="social-icon"><i class="bi bi-facebook"></i></a>
            <a href="https://www.instagram.com/nilkhetbd" target="_blank" class="social-icon"><i class="bi bi-instagram"></i></a>
            <a href="https://wa.me/8801711086468" target="_blank" class="social-icon"><i class="bi bi-whatsapp"></i></a>
          </div>
        </div>

        <!-- Need Help Section -->
        <div class="col-lg-3 mb-4 mb-lg-0">
          <h5 class="section-title">Need Help</h5>
          <div class="phone-number">
            <a href="tel:+8801711086468" class="support-number">+880 1711 086 468</a>
          </div>
          <div class="working-hours mt-3">
            <!-- <p class="mb-1">Monday - Friday: 9:00-20:00</p>
            <p>Saturday: 11:00 - 15:00</p> -->
            <p>24/7 Support</p> 
          </div>
          <div class="contact-email mt-3">
            <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>
          </div>
        </div>

        <!-- Explore Section -->
        <div class="col-lg-2 mb-4 mb-lg-0">
          <h5 class="section-title">Explore</h5>
          <ul class="footer-links">
            <li>
              <router-link to="/about"> 
                About us
              </router-link>
            </li>
            <li>
              <router-link to="/search"> 
                book list
              </router-link>
            </li>
            <li>
              <router-link to="/signup"> 
                Sign up
              </router-link>
            </li>
            <li>
              <router-link to="/login"> 
                Sign in
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Our Service Section -->
        <div class="col-lg-2 mb-4 mb-lg-0">
          <h5 class="section-title">Our Service</h5>
          <ul class="footer-links">
            <li>
              <router-link :to="{ path: '/contact' }" > 
                  Help Center
              </router-link>
            </li>
            <li>
              <router-link v-if="isLoggedIn" to="/orders"> 
                  Track Order
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/contact' }">
                  Contact Us
              </router-link>
            </li>
            <li>
              <router-link to="/faq">
                  FAQ
              </router-link>
            </li>
            <li>
              <router-link to="/return-refund-policy">
                  Return &amp; Refund
              </router-link>
            </li>
            <li>
              <router-link to="/delivery-policy">
                  Delivery Policy
              </router-link>
            </li>
            <li>
              <router-link to="/privacy-policy">
                  Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link to="/terms">
                  Terms &amp; Conditions
              </router-link>
            </li>
          </ul>
        </div>

        <!-- Categories Section -->
        <div class="col-lg-2 mb-4 mb-lg-0">
          <h5 class="section-title">Categories</h5>
          <ul class="footer-links">
            <li>
              <router-link :to="{ path: '/category', query: { c: 'business' } }">
                  Business
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/category', query: { c: 'self_help' } }">
                  Self Help
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/category', query: { c: 'literature' } }"> 
                  Literature
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/category', query: { c: 'science_fiction' } }">
                  Science Fiction
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/category', query: { c: 'children_and_teens' } }">
                  Kids
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Copyright Section -->
    <div class="copyright-bar">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order-2 order-md-1">
            <p class="copyright-text">Copyright © {{ currentYear }} <a href="#">Nilkhet Books</a>. All rights reserved.</p>
            <p class="legal-links">
              <router-link to="/privacy-policy">Privacy Policy</router-link>
              <span class="divider">|</span>
              <router-link to="/terms">Terms &amp; Conditions</router-link>
            </p>
          </div>
          <div class="col-md-6 text-md-end py-2 order-1 order-md-2">
            <div class="payment-methods justify-content-center justify-content-md-end">
              We accept
              <span class="d-flex gap-2 px-2 bg-light payment-logos">
                <img src="https://nilkhet-books-prod.merajkazi20.workers.dev/Bkash-Logo-1.png" alt="Bkash" class="payment-icon" />
                <img src="https://nilkhet-books-prod.merajkazi20.workers.dev/1786114104573_nagad-logo-1-small.png" alt="Nagad" class="payment-icon" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #282828;
  color: #ffffff;
  
  .footer-logo {
    display: flex;
    align-items: center;
    
    .logo {
      height: 40px;
      margin-right: 10px;
    }
    
    .logo-text {
      font-size: 24px;
      font-weight: 600;
      color: #ffffff;
    }
  }
  
  .address {
    color: #a0a0a0;
    font-size: 14px;
    line-height: 1.5;
  }
  
  .map-btn {
    background: none;
    border: none;
    border-bottom: 1px solid #ff6b6b;
    color: #ff6b6b;
    text-decoration: none;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
  
  .social-icons {
    display: flex;
    gap: 15px;
    
    .social-icon {
      color: #a0a0a0;
      font-size: 18px;
      
      &:hover {
        color: #ff6b6b;
      }
    }
  }
  
  .section-title {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  
  .phone-number {
    a {
      color: #ff6b6b;
      font-size: 24px;
      font-weight: 600;
      text-decoration: none;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
  
  .working-hours {
    color: #a0a0a0;
    font-size: 14px;
  }
  
  .contact-email {
    a {
      color: #a0a0a0;
      text-decoration: none;
      
      &:hover {
        color: #ff6b6b;
      }
    }
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: 10px;
      
      a {
        color: #a0a0a0;
        text-decoration: none;
        font-size: 14px;
        
        &:hover {
          color: #ff6b6b;
        }
      }
    }
  }
  
  .copyright-bar {
    border-top: 1px solid #2d2d2d;
    padding: 20px 0;
    
    .copyright-text {
      color: #a0a0a0;
      font-size: 14px;
      margin: 0;

      a {
        color: #ff6b6b;
        text-decoration: none;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .legal-links {
      margin: 6px 0 0;
      font-size: 13px;

      a {
        color: #a0a0a0;
        text-decoration: none;

        &:hover {
          color: #ff6b6b;
        }
      }

      .divider {
        color: #555;
        margin: 0 8px;
      }
    }
    
    .payment-methods {
      display: flex;
      align-items: center;
      gap: 10px;
      justify-content: flex-end;

      .payment-logos {
        border-radius: 6px;
      }

      .payment-icon {
        height: 35px;
      }
    }
  }
}
</style>
